import { InputNumber as AntInputNumber } from 'antd';
import styled from 'src/theme';

export const InputNumber = styled(props => <AntInputNumber {...props} />)`
  &.ant-input-number-focused,
  &:focus,
  &:hover {
    border-color: ${props => props.theme.colors.orange} !important;
    box-shadow: unset !important;
  }
  .ant-input-number-handler:hover .ant-input-number-handler-up-inner, 
  .ant-input-number-handler:hover .ant-input-number-handler-down-inner {
    color: ${props => props.theme.colors.orange} !important;
  }
`;
